export default __webpack_public_path__ + "static/media/globe.0bc16ea8.mp3";